import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import useAsync from '../../hooks/useAsync';
import HotChartServices from '../../services/HotChartServices';
import HelpTogal from './TogelButton/HotChartTogal';
import DeleteButton from './Button/DeleteButton';
import HotChartUpdate from './Update Model/HotChartUpdate';

Modal.setAppElement('#root');

function HotChart() {
  const { data, error, isLoading, run } = useAsync(HotChartServices.getHotChart);
  const [activeIndex, setActiveIndex] = useState(null);
  const [modal, setModal] = useState({ type: null, data: null });
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  const charts = data?.data || [];

  useEffect(() => {
    if (charts.length > 0) {
      const filtered = charts.filter(({ symbol = '', description = '' }) =>
        symbol.toLowerCase().includes(searchTerm.toLowerCase()) ||
        description.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [charts, searchTerm]);

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const openModal = (type, data) => {
    setModal({ type, data });
    toggleActionMenu(null);
  };

  const closeModal = () => {
    setModal({ type: null, data: null });
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString();
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Hot Chart List <span className="badge bg-orange">{charts.length}</span></h2>
        <div className="container-box-top-header-right">
          <Link className="round-add-btn" to="/admin/add-hotchart"><img src="img/plus.svg" alt="" /></Link>
        </div>
      </div>

      <div className="container-box px-0">
        <div className="container-box-top-header px-4">
          <div className="container-box-top-header-left-2">
            <input
              type="search"
              name="search"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <button className="search-btn">Search</button>
          </div>
        </div>

        <div className="container-box-inner">
          <table className="table table-striped" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>#</th>
                <th>Image</th>
                <th>Symbol</th>
                <th>Description</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
                <tr key={item._id || index}>
                  <td>{index + 1}</td>
                  <td>
                    <div className="product-img">
                      <img src={`${process.env.REACT_APP_URL}${item.image}`} alt="hotchart" />
                    </div>
                  </td>
                  <td>{item.symbol}</td>
                  <td>{formatDate(item.createdAt)}</td>
                  <td className="status-toggle">
                    <HelpTogal help={item} page="hotchart" onSuccess={run} />
                  </td>
                  <td>
                    <div className="action_toggle_outer">
                      <button className="action_toggle" onClick={() => toggleActionMenu(index)}>
                        <i className="fa fa-ellipsis-v" />
                      </button>
                      {activeIndex === index && (
                        <div className="action_toggle_content product-edit show d-block">
                          <ul className="list-unstyled">
                            <li><button className="close_toggle" onClick={() => toggleActionMenu(null)}><i className="fa fa-close" /></button></li>
                            <li><button className="edit" onClick={() => openModal('edit', item)}>Edit</button></li>
                            <li><button className="reject" onClick={() => openModal('delete', item)}>Delete</button></li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {filteredData.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center">No Hot Chart Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modals */}
      <Modal
        isOpen={modal.type === 'edit'}
        onRequestClose={closeModal}
        contentLabel="Edit HotChart"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <HotChartUpdate hotchart={modal.data} closeModal={closeModal} onSuccess={run} />
      </Modal>

      <Modal
        isOpen={modal.type === 'delete'}
        onRequestClose={closeModal}
        contentLabel="Delete HotChart"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <DeleteButton data={modal.data} page="hotchart" closeModal={closeModal} onSuccess={run} />
      </Modal>
    </div>
  );
}

export default HotChart;
